const initialState = {
  result: {
    items: [],
    related: [],
    total: -1
  }
}

export default function search (state = initialState, action) {
  switch (action.type) {
    case 'SEARCH_RESULT':
      return { result: { ...action.payload } }
    case 'SEARCH_ERROR':
      return { result: { ...state.result } }
    default:
      return state
  }
}
